import React, { useState } from "react";
import Nav from "./Nav";
import Hero from "./Hero";
import Dores from "./Dores";
import Categorias from "./Categorias";
import ComoFunciona from "./ComoFunciona";
import TempoReal from "./TempoReal";
import Produtor from "./Produtor";
import Pagamentos from "./Pagamentos";
import Parceiro from "./Parceiro";
import Aplicativo from "./Aplicativo";
import Perguntas from "./Perguntas";
import ChamadaFinal from "./ChamadaFinal";
import Rodape from "./Rodape";
import LeadModal from "../LeadModal";
import { trackEvent, trackModalOpen } from "../../utils/analytics";

const HomePage: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const handleOpenModal = (): void => {
    setIsModalOpen(true);
    trackModalOpen();
    trackEvent("cta_click", {
      source: "home",
      action: "open_early_access_modal",
    });
  };

  const handleCloseModal = (): void => setIsModalOpen(false);

  return (
    <div className="bg-bone font-inter text-soil">
      <Nav onOpenModal={handleOpenModal} />
      <main>
        <Hero onOpenModal={handleOpenModal} />
        <Dores />
        <Categorias />
        <ComoFunciona />
        <TempoReal />
        <Produtor onOpenModal={handleOpenModal} />
        <Pagamentos />
        <Parceiro />
        <Aplicativo onOpenModal={handleOpenModal} />
        <Perguntas />
        <ChamadaFinal onOpenModal={handleOpenModal} />
      </main>
      <Rodape onOpenModal={handleOpenModal} />
      <LeadModal isOpen={isModalOpen} onClose={handleCloseModal} />
    </div>
  );
};

export default HomePage;
